<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <i class="fas fa-check fa-lg text-success col-1 text-center border-success border-circle"></i>
                    <p class="col-11 m-0">
                        <strong>{{ message }}</strong>
                    </p>
                </div>
            </div>

            <div class="col-6 order-0 col-md-3 order-md-1 checkout-image-box text-center">
                <!--<img :src="imageUrl" alt="" class="img-fluid border-dark d-none d-sm-none d-md-block">-->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TimeBox",
        props: {
            message: String,
            imageUrl: String
        },
        computed: {
        },
        data() {
            return {}
        }
    }
</script>

<style scoped lang="scss">
    p {
        text-align: start;
    }
</style>